export const PAGE_SIZE = 20
export const SET_GEO_LOCATION_ACTION = "SET_GEO_LOCATION"
export const SET_INFINITE_SCROLL_POSITION = "SET_INFINITE_SCROLL_POSITION"
export const SET_INVENTORY_FILTER_ACTION = "SET_INVENTORY_FILTER"
export const INIT_INVENTORY_FILTER_ACTION = "INIT_INVENTORY_FILTER"
export const FETCH_INSTANT_BOOK_SERVICES_ACTION =
  "FETCH_INSTANT_BOOK_SERVICES_ACTION"
export const RE_FETCH_INSTANT_BOOK_SERVICES_ACTION =
  "RE_FETCH_INSTANT_BOOK_SERVICES_ACTION"
